import { useState, useMemo, memo } from 'react';
import { StepType } from '../../../utilites/StepType';
import { Button, Popover, Box, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { Formik, Form } from 'formik';


const StepModify = ({ selectedNode, onStepTypeChange }: { selectedNode: any; onStepTypeChange: (type: string, shouldClearFields?: boolean) => void }) => {
  const currentType = useMemo(() => selectedNode?.data?.step?.stepType || '', [selectedNode]); 

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <Button variant="outlined" color="primary" size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        Modify Activity
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <Box sx={{ p: 2, minWidth: 100 }}>
     <Formik
          initialValues={{ stepType: currentType }}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            // Clear fields when step type changes
            const shouldClearFields = values.stepType !== currentType;
            onStepTypeChange(values.stepType, shouldClearFields);  
            setSubmitting(false);
            setAnchorEl(null);
          }}
        >
            {({ isSubmitting, values, handleChange }) => (
              <Form>
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="step-type-label">Step Type</InputLabel>
                  <Select labelId="step-type-label" name="stepType" value={values.stepType} onChange={handleChange} fullWidth>
                    {Object.values(StepType).map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="small"
                  fullWidth
                  disabled={isSubmitting || values.stepType === currentType}
                >
                  Change
                </Button>
              </Form>
            )}
          </Formik>
        </Box>
      </Popover>
    </>
  );
};

export default memo(StepModify);
